import { IConflictRegionDto } from "@kuika/kuika-cl-model/src/dtos/branch.dto";
import { entityTypeFromFilePath } from "./entity-content-summary";

/** Entity types where Xml is a redundant derivative of Json. */
const ENTITY_TYPES_WITH_REDUNDANT_XML = new Set([4, 5, 7]); // KWorkFlow, KApiManagement, KScheduledJobs

export function hasRedundantXml(filePath: string): boolean {
  const entityType = entityTypeFromFilePath(filePath);
  return entityType !== null && ENTITY_TYPES_WITH_REDUNDANT_XML.has(entityType);
}

export function isXmlRegion(region: IConflictRegionDto): boolean {
  const path = ((region as unknown as Record<string, string>)?.conflictPath as string) || "";
  const normalized = path.toLowerCase();
  return normalized === "/xml" || normalized.startsWith("/xml/");
}

export function isJsonRegion(region: IConflictRegionDto): boolean {
  const path = ((region as unknown as Record<string, string>)?.conflictPath as string) || "";
  const normalized = path.toLowerCase();
  return normalized === "/json" || normalized.startsWith("/json/");
}

/**
 * Auto-resolve Xml conflict regions in a file when the corresponding Json region is resolved.
 * Uses the same strategy (ours/theirs content) as the Json region.
 */
export function autoResolveLinkedXmlRegions(
  fileConflict: { filePath: string; conflicts: IConflictRegionDto[] },
  resolvedRegion: IConflictRegionDto
): void {
  if (!hasRedundantXml(fileConflict.filePath)) return;
  if (!isJsonRegion(resolvedRegion)) return;

  for (const region of fileConflict.conflicts) {
    if (isXmlRegion(region) && !region.isResolved) {
      region.isResolved = true;
      const resolvedContent = resolvedRegion.resolvedContent ?? "";
      const oursContent = (resolvedRegion.ours ?? "").trim();
      const theirsContent = (resolvedRegion.theirs ?? "").trim();
      const baseContent = ((resolvedRegion as unknown as Record<string, string>)?.base ?? "").trim();

      if (resolvedContent.trim() === oursContent) {
        region.resolvedContent = region.ours;
      } else if (resolvedContent.trim() === theirsContent) {
        region.resolvedContent = region.theirs;
      } else if (resolvedContent.trim() === baseContent) {
        region.resolvedContent = (region as unknown as Record<string, string>)?.base ?? region.ours;
      } else {
        region.resolvedContent = region.ours;
      }
    }
  }
}
